import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart } from '@fortawesome/free-solid-svg-icons'

const Processing = ({ children }) =>
  <div className="processing text-center">
    <p className="text-primary">
      <span className="heartbeat">
        <FontAwesomeIcon icon={faHeart} size="5x" />
      </span>
    </p>
    {children}
  </div>

export default Processing
